module.exports = __webpack_public_path__ + "static/imagem-05-equipamentos-729d6285e03ef3e21dbe43831c6b8386.jpg";